export default __webpack_public_path__ + "static/media/googleplay_ko_badge_web.184c2eaa.png";